import { couponUnlockCodeQuery } from "@saleor/coupons/queries";
import {
  couponUnlockCode,
  couponUnlockCodeVariables
} from "@saleor/coupons/types/couponUnlockCode";
import useAppState from "@saleor/hooks/useAppState";
import useNotifier from "@saleor/hooks/useNotifier";
import { useApolloClient } from "react-apollo";
import { useIntl } from "react-intl";

import { downloadBase64Image } from "../utils";

const useDownloadQr = () => {
  const intl = useIntl();
  const notify = useNotifier();
  const [, dispatchAppState] = useAppState();
  const client = useApolloClient();

  const downloadUnlockCodeQr = (
    unlockCodeId: string,
    fileName: string
  ) => () => {
    dispatchAppState({
      payload: {
        value: true
      },
      type: "displayLoader"
    });
    client
      .query<couponUnlockCode, couponUnlockCodeVariables>({
        fetchPolicy: "network-only",
        query: couponUnlockCodeQuery,
        variables: { unlockCodeId }
      })
      .then(response => {
        downloadBase64Image(response.data.couponUnlockCode.qrCode, fileName);
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Unlock Code downloaded successfully."
          })
        });
      })
      .catch(() => {
        notify({
          status: "error",
          text: intl.formatMessage({
            defaultMessage: "An error occured."
          })
        });
      })
      .finally(() => {
        dispatchAppState({
          payload: {
            value: false
          },
          type: "displayLoader"
        });
      });
  };

  return { downloadUnlockCodeQr };
};

export default useDownloadQr;
